import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface ResultItemProps {
  label: string;
  value: string;
  highlight?: boolean;
  icon?: LucideIcon;
}

export function ResultItem({ label, value, highlight = false, icon: Icon }: ResultItemProps) {
  return (
    <div
      className={`rounded-lg border p-4 ${
        highlight ? "border-accent bg-accent/5" : "bg-secondary/50"
      }`}
    >
      <div className="flex items-center gap-2">
        {Icon && <Icon className={`h-4 w-4 ${highlight ? "text-accent" : "text-muted-foreground"}`} />}
        <p className="text-sm text-muted-foreground">{label}</p>
      </div>
      <p className={`mt-1 text-2xl font-bold ${highlight ? "text-accent" : "text-foreground"}`}>
        {value}
      </p>
    </div>
  );
}

interface CalculatorResultsProps {
  results: ResultItemProps[];
  title?: string;
}

export function CalculatorResults({ results, title }: CalculatorResultsProps) {
  return (
    <div className="space-y-4">
      {title && <h4 className="font-semibold text-foreground">{title}</h4>}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {results.map((result, index) => (
          <ResultItem key={index} {...result} />
        ))}
      </div>
    </div>
  );
}
